enum ApplicationType {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
  SECURED_CREDIT = "SECURED_CREDIT",
  CHARGE = "CHARGE",
}

export default ApplicationType;
